/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // Color swatch selection updates size availability
    // Color swatch selection updates size availability
  // Uses event delegation + a MutationObserver so it also works for
  // products loaded via AJAX (filters, pagination, infinite scroll).

  function updateSizeAvailability(productItem, selectedColor) {
    const sizeSwatchWrap = productItem.querySelector('[data-size-swatches]');
    if (!sizeSwatchWrap || !selectedColor) return;

    sizeSwatchWrap.querySelectorAll('.size-swatch-link').forEach(function(sizeLink) {
      const availableColors = (sizeLink.getAttribute('data-available-colors') || '')
        .split(',')
        .map(function(c) { return c.trim(); })
        .filter(Boolean);
      const sizeText = sizeLink.querySelector('.size-swatch-text');
      if (!sizeText) return;

      // No colour data at all (e.g. product has no colour option):
      // leave the server-rendered state alone.
      if (!sizeLink.hasAttribute('data-available-colors')) return;

      const isAvailableInColor = availableColors.indexOf(selectedColor.trim()) !== -1;

      if (isAvailableInColor) {
        sizeLink.classList.remove('disabled');
        sizeLink.removeAttribute('aria-disabled');
        sizeText.style.textDecoration = 'none';
        sizeText.style.opacity = '1';
      } else {
        sizeLink.classList.add('disabled');
        sizeLink.setAttribute('aria-disabled', 'true');
        sizeText.style.textDecoration = 'line-through';
        sizeText.style.opacity = '0.5';
      }
    });
  }

  // Sync a card to whichever colour is currently active/displayed
  function syncGridItem(productItem) {
    const activeColorSwatch = productItem.querySelector('[data-color][aria-current="true"]');
    if (activeColorSwatch) {
      updateSizeAvailability(productItem, activeColorSwatch.getAttribute('data-color'));
    }
  }

  function syncAllGridItems() {
    document.querySelectorAll('product-grid-item').forEach(syncGridItem);
  }

  // One delegated listener instead of per-card listeners, so swatches on
  // AJAX-loaded cards work too
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('[data-color]');
    if (!swatch) return;
    const productItem = swatch.closest('product-grid-item');
    if (!productItem) return;
    updateSizeAvailability(productItem, swatch.getAttribute('data-color'));
  });

  document.addEventListener('DOMContentLoaded', function() {
    syncAllGridItems();

    // Re-sync any product cards added to the page after initial load
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return; // elements only
          if (node.matches && node.matches('product-grid-item')) {
            syncGridItem(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('product-grid-item').forEach(syncGridItem);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

})();

